(() => {
  const roots = document.querySelectorAll('[data-sj-scooter-lower]');
  roots.forEach((root) => {
    if (root.dataset.sjLowerReady === 'true') return;
    root.dataset.sjLowerReady = 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    root.querySelectorAll('.sj-product-information__item').forEach((details) => {
      const summary = details.querySelector('summary');
      const panel = details.querySelector('.sj-product-information__panel');
      if (!summary || !panel) return;

      summary.addEventListener('click', (event) => {
        if (reduceMotion.matches || typeof panel.animate !== 'function') return;
        event.preventDefault();
        const opening = !details.open;
        if (opening) details.open = true;
        const from = opening ? 0 : panel.scrollHeight;
        const to = opening ? panel.scrollHeight : 0;
        panel.getAnimations().forEach((animation) => animation.cancel());
        const animation = panel.animate(
          [
            { height: `${from}px`, opacity: opening ? 0 : 1 },
            { height: `${to}px`, opacity: opening ? 1 : 0 }
          ],
          { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
        animation.addEventListener('finish', () => {
          panel.style.height = '';
          panel.style.opacity = '';
          if (!opening) details.open = false;
        }, { once: true });
      });
    });
  });

  const hero = document.querySelector('.sj-hybrid--scooter');
  if (!hero || hero.dataset.sjhSupportReady === 'true') return;
  hero.dataset.sjhSupportReady = 'true';

  const featureItems = Array.from(hero.querySelectorAll('[data-sjh-feature-original] [data-sjh-feature-open]'));
  const sizeModal = hero.querySelector('[data-sjh-modal="size-guide"]');
  const featureModal = hero.querySelector('[data-sjh-modal="features"]');
  const featureImage = featureModal?.querySelector('[data-sjh-feature-modal-image]');
  const featureTitle = featureModal?.querySelector('[data-sjh-feature-modal-title]');
  const featureCounter = featureModal?.querySelector('[data-sjh-feature-modal-counter]');
  let activeFeatureIndex = 0;
  let activeModal = null;
  let returnFocus = null;
  let inertSiblings = [];
  let touchStartX = null;

  const focusable = (container) => Array.from(container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'))
    .filter((element) => !element.hidden && element.getClientRects().length);

  const setPageInert = (modal, inert) => {
    if (inert) {
      inertSiblings = Array.from(document.body.children).filter((element) => element !== modal && !element.matches('script,style,link'));
      inertSiblings.forEach((element) => { element.inert = true; });
    } else {
      inertSiblings.forEach((element) => { element.inert = false; });
      inertSiblings = [];
    }
  };

  const renderFeature = (nextIndex) => {
    if (!featureItems.length || !featureImage) return;
    activeFeatureIndex = (nextIndex + featureItems.length) % featureItems.length;
    const item = featureItems[activeFeatureIndex];
    featureImage.src = item.href;
    featureImage.alt = item.querySelector('img')?.alt || item.dataset.sjhFeatureTitle || `Scooter feature ${activeFeatureIndex + 1}`;
    if (featureTitle) featureTitle.textContent = item.dataset.sjhFeatureTitle || 'SCOOTER FEATURE';
    if (featureCounter) featureCounter.textContent = `${activeFeatureIndex + 1} OF ${featureItems.length}`;
  };

  const closeModal = () => {
    if (!activeModal) return;
    const closing = activeModal;
    activeModal = null;
    closing.hidden = true;
    closing.removeAttribute('data-sjh-open');
    document.body.classList.remove('sj-modal-open');
    hero.dataset.sjhFeatureModalOpen = 'false';
    setPageInert(closing, false);
    if (closing.parentElement === document.body) hero.appendChild(closing);
    returnFocus?.focus({ preventScroll: true });
    returnFocus = null;
  };

  const openModal = (modal, trigger) => {
    if (!modal) return;
    if (activeModal) closeModal();
    returnFocus = trigger || document.activeElement;
    document.body.appendChild(modal);
    modal.hidden = false;
    modal.dataset.sjhOpen = 'true';
    activeModal = modal;
    document.body.classList.add('sj-modal-open');
    if (modal === featureModal) hero.dataset.sjhFeatureModalOpen = 'true';
    setPageInert(modal, true);
    requestAnimationFrame(() => (modal.querySelector('[data-sjh-modal-close]') || modal.querySelector('[role="dialog"]'))?.focus({ preventScroll: true }));
  };

  hero.querySelector('[data-sjh-size-guide-open]')?.addEventListener('click', (event) => {
    event.preventDefault();
    openModal(sizeModal, event.currentTarget);
  });

  hero.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sjh-feature-open]');
    if (!trigger || !hero.contains(trigger)) return;
    event.preventDefault();
    renderFeature(Number(trigger.dataset.sjhFeatureIndex || 0));
    openModal(featureModal, trigger);
  });

  [sizeModal, featureModal].filter(Boolean).forEach((modal) => {
    modal.querySelector('[data-sjh-modal-close]')?.addEventListener('click', closeModal);
    modal.querySelector('[data-sjh-modal-backdrop]')?.addEventListener('click', closeModal);
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (modal === featureModal && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
        event.preventDefault();
        renderFeature(activeFeatureIndex + (event.key === 'ArrowRight' ? 1 : -1));
        return;
      }
      if (event.key !== 'Tab') return;
      const controls = focusable(modal);
      if (!controls.length) return;
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });

  featureModal?.querySelector('[data-sjh-feature-modal-prev]')?.addEventListener('click', () => renderFeature(activeFeatureIndex - 1));
  featureModal?.querySelector('[data-sjh-feature-modal-next]')?.addEventListener('click', () => renderFeature(activeFeatureIndex + 1));
  featureModal?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
  featureModal?.addEventListener('touchend', (event) => {
    if (touchStartX == null) return;
    const delta = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
    touchStartX = null;
    if (Math.abs(delta) >= 48) renderFeature(activeFeatureIndex + (delta < 0 ? 1 : -1));
  }, { passive: true });
})();
